import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from "../api/api";
import '../style/PortalLogin.css';
import loginSvg from '../icons/undraw_access-account_aydp.svg';
import logo from '../icons/logo.svg';

const PortalLogin = ({ onLoginSuccess }) => {
  const { role } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (role === 'admin') {
  try {
    const res = await api.post('/api/admin/login', {
      email: formData.username,
      password: formData.password
    });

    const admin = res.data;

    localStorage.setItem('role', 'admin');
    localStorage.setItem('userId', admin.id);
    localStorage.setItem('token', admin.token);
    localStorage.setItem('schoolId', admin.school_id); 

    navigate(`/admin/${admin.id}/dashboard`);
    return;
  } catch (err) {
    setError(err.response?.data?.error || "Invalid email or password");
    return;
  }
}

    if (role === 'superadmin') {
  try {
    const res = await api.post('/api/superadmin/login', {
      email: formData.username,
      password: formData.password
    });

    const superAdmin = res.data;

    localStorage.setItem('role', 'superadmin');
    localStorage.setItem('userId', superAdmin.id);
    localStorage.setItem('token', superAdmin.token);

    navigate(`/superadmin/${superAdmin.id}/dashboard`);
    return;
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.error || "Invalid email or password");
    return;
  }
}

if (role === 'teacher') {
  try {
    const res = await api.post('/api/teachers/login', {
      email: formData.username,
      password: formData.password
    });

    const teacher = res.data;

    // ✅ SAVE ALL REQUIRED DATA
    localStorage.setItem('role', 'teacher');
    localStorage.setItem('userId', teacher.teacher_id);
    localStorage.setItem('teacherId', teacher.teacher_id);
    localStorage.setItem('token', teacher.token);
    localStorage.setItem('schoolId', teacher.school_id);   // ⭐ ADD THIS

    navigate(`/teacher/${teacher.teacher_id}/teacher-dashboard`);
    return;
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.error || "Invalid email or password");
        return;
      }
    }

if (role === 'parent') {
  try {
    const res = await api.post('/api/students/login', {
      email: formData.username,
      password: formData.password
    });

    const parent = res.data;

    // ✅ Save everything needed
    localStorage.setItem('role', 'parent');
    localStorage.setItem('userId', parent.student_id);
    localStorage.setItem('token', parent.token);
    localStorage.setItem('schoolId', parent.school_id);   // ⭐ ADD THIS

    navigate(`/parent/${parent.student_id}/dashboard`);
    return;
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.error || "Invalid email or password");
    return;
  }
}

    // Fallback for other roles
    const data = {
      userId: Math.floor(Math.random() * 1000),
      teacher_id: null,
      role: role || 'guest',
    };

    localStorage.setItem('role', data.role);
    localStorage.setItem('userId', data.userId);

    onLoginSuccess(data, navigate);
  };

  const handleBackToRoleSelect = () => navigate("/");

  return (
    <div className="portal-login-wrapper">
       <img src={logo} alt="School ERP Logo" className="portal-company-logo" />
      <div className="portal-login-card">
        <div className="tracer top"></div>
        <div className="tracer right"></div>
        <div className="tracer bottom"></div>
        <div className="tracer left"></div>

        <div className="portal-login-left">
          <div className="portal-logo-header">
           
            <span className="portal-company-name">Semigon School ERP</span>
          </div>

          <h2>{role ? role.toUpperCase() : "PORTAL"} LOGIN</h2>
          {error && <p className="error-text">{error}</p>}

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="username"
              placeholder="Email"
              value={formData.username}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button type="submit">Login</button>
          </form>

          <button className="back-btn" onClick={handleBackToRoleSelect}>
            Home Page
          </button>
        </div>

        <div className="portal-login-right">
          <img src={loginSvg} alt="Login Illustration" />
        </div>
      </div>
    </div>
  );
};

export default PortalLogin;
